import React from 'react';
import './NewsContact.css';

function NewsContact() {
  return (
    <section className="main-footer-cta">
      <div className="contain">
        <section className="cta">
          <div className="content">
            <div className="grow">
              <div className="wysiwyg">
                <h2 className="style-h4">Ready to improve customer communications?</h2>
              </div>
            </div>
            <div>
              <div className="buttons">
                <a href="/news" role="link" className="btn theme-pill">
                  <span className="slot">Contact sales</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

export default NewsContact;